import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function RecommendMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.recommend.list);
  };

  return (
    <MainMenuItem
      itemTitleString="おすすめ\n商品の管理"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default RecommendMenuItem;
